!((document, Drupal, $) => {
  'use strict';

  /**
   * Get event data and create Add To Calendar
   */
  Drupal.behaviors.ikeHeader = {
    attach: function (context) {

      const eventDetails = context.querySelectorAll('.event_details_calendar');
      if (eventDetails != null) {
        eventDetails.forEach(function (el) {
          const eventStartDate = el.dataset.eventStartDate;
          const eventEndDate = el.dataset.eventEndDate;
          let eventDescription = context.querySelector('.event_detail_info')

          if (eventDescription != null) {
            eventDescription = eventDescription.innerText;

            if (eventDescription == null) {
              eventDescription = '';
            }
          }

          let myCalendar = createCalendar({
            options: {
              class: 'collapsible jcl-menu collapsed calendar-add',
            },
            data: {
              title: el.dataset.eventTitle,
              start: new Date(eventStartDate),
              end: new Date(eventEndDate),
              address: el.dataset.eventAddress,
              description: eventDescription
            }
          });
          el.appendChild(myCalendar);

          $('.legend').unbind('click').click(function (e) {
            $(this).parent().find(".jcl-menu-wrapper").slideToggle();
          });

        });
      }
    }
  };
})(document, Drupal, jQuery);
